import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { postLoginPath } from "../lib/roles";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        navigate(postLoginPath(data), { replace: true });
      } catch (e) {
        navigate("/login?error=oauth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-aurora" data-testid="auth-callback">
      <div className="glass-card px-10 py-8 text-center">
        <div className="animate-pulseglow inline-block w-12 h-12 rounded-full bg-neonpink mb-4" />
        <p className="font-display text-xl">Signing you in...</p>
      </div>
    </div>
  );
}
